import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "intelligence-data-engine",
  "use": "intelligence-data-engine-usage",
  "viewBox": "0 0 59 60",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 59 60\" id=\"intelligence-data-engine\"><path d=\"M57.625 13.127c0 6.214-12.592 11.25-28.125 11.25S1.375 19.341 1.375 13.127m56.25 0c0-6.213-12.592-11.25-28.125-11.25S1.375 6.914 1.375 13.127m56.25 0V30M1.375 13.127V30m0 0c0 6.212 12.592 11.25 28.125 11.25 15.532 0 28.125-5.035 28.125-11.25m-56.25 0v16.875c0 6.212 12.592 11.25 28.125 11.25 15.532 0 28.125-5.038 28.125-11.25V30\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/img/svg/intelligence-data-engine.svg
// module id = u0nw
// module chunks = 39 44